import { useState, useEffect } from 'react';
import { api } from '../lib/api';

let cache: Record<string, string> | null = null;
let fetchPromise: Promise<Record<string, string>> | null = null;

async function fetchContents(): Promise<Record<string, string>> {
  if (cache) return cache;
  if (!fetchPromise) {
    fetchPromise = fetch(api('/api/catalog/contents')).then(r => r.json()).then(d => { cache = d; return d; }).catch(() => (cache || {}));
  }
  return fetchPromise;
}

export function useContent() {
  const [contents, setContents] = useState<Record<string, string>>(cache || {});

  useEffect(() => {
    fetchContents().then(setContents);
  }, []);

  return contents;
}

export function refreshContent() {
  cache = null;
  fetchPromise = null;
}